import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../../Types";


let fieldOperations: FieldOperations = {
    inmsg_id: [...OpsCategories.eq, ...OpsCategories.in,],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    dt: [...OpsCategories.range],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};


const statusMap = {
    backgroundColor: '#18111c',
    values: {
        "-1": {
            rawValue: -1,
            lang: {
                ua: "У черзі",
            },
            color: '#3e82ea'
        },
        "0": {
            rawValue: "0",
            lang: {
                ua: "Нове",
                en: "START"
            },
            color: '#9718d2'
        },
        "1": {
            rawValue: "1",
            lang: {
                ua: "Успіх",
            },
            color: '#32d922'
        },
        "2": {
            rawValue: "2",
            lang: {
                ua: "Неправильний номер",
            },
            color: '#d5060d'
        },
        "3": {
            rawValue: "3",
            lang: {
                ua: "Помилка",
            },
            color: '#d5060d'
        },
        "4": {
            rawValue: "4",
            lang: {
                ua: "В обробці",
            },
            color: '#e7d026'
        }
    }
} as FieldMap;


export const PaymentsTable: TableI = {
    backend: "/287/",
    title: {
        ua: "Поповнення",
    },
    pk: 'id',
    forAdmin: true,
    defaultOrderedBy: "inmsg_id",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID"},
        "inmsg_id": {ua: "ID поповнення"},
        "dt": {ua: "Створено"}
    },
    fieldOperations: fieldOperations,
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "#"},
            type: "number",
            applyTransform: true
        },
        {
            key: "dt",
            title: {ua: "Створено"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            inline: true,
            detailed: true,
            headAlign: "left"
        },
        {
            key: "msisdn",
            type: 'tel',
            applyTransform: true,
            detailed: true, inline: true,
            title: {ua: "Телефон",},
            headAlign: "left",
            searchRef: [
                {
                    table: "payments",
                    condition: [{
                        mainField: "msisdn",
                        op: SqlOperation.EQUAL
                    }]
                }
            ]
        },

        {
            key: "amount",
            detailed: true,
            inline: true,
            title: {ua: "Сума"},
            type: "number",
            applyTransform: true,

        },
        {
            key: "status_id",
            title: {ua: "Статус"},
            detailed: true,
            inline: true,
            type: 'map',
            map: statusMap,
            applyTransform: true,
            headAlign: "left"
        },
        {
            key: "inmsg_id",
            detailed: true,
            inline: true,
            title: {ua: "ID поповнення"},
            type: "number",
            applyTransform: true,
            searchRef: [
                {
                    table: "payments",
                    condition: [{
                        mainField: "inmsg_id",
                        op: SqlOperation.EQUAL
                    }]
                }
            ]
        },
        {
            key: "error_text",
            detailed: true,
            title: {ua: "Текст помилки"},
            type: "string",
            applyTransform: true
        },
        {
            key: "comment",
            detailed: true,
            title: {ua: "Коментар 1"},
            type: "string",
            applyTransform: true
        },
        {
            key: "comment2",
            detailed: true,
            title: {ua: "Коментар 2"},
            type: "string",
            applyTransform: true
        },
        {
            key: "comment3",
            detailed: true,
            title: {ua: "Коментар 3"},
            type: "string",
            applyTransform: true
        },

        {
            key: "timestamp",
            title: {ua: "Час"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            inline: false,
            detailed: true
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID"},
            type: "number",
            applyTransform: true
        },
        {
            key: "ref_order",
            title: {ua: "Замовлення поповнень"},
            detailed: true,
            applyTransform: true,
            type: 'ref',
            ref: {
                entity: "order",
                keys: ['n', 'id', 'dt', 'prize_id', 'rate', 'deleted'],
                fetchMode: "superLazy",
                order: {
                    field: "dt",
                    way: "DESC"
                },
                limit: 5,
                layout: "table",
                condition: [
                    {
                        mainField: "msisdn",
                        op: SqlOperation.EQUAL
                    },
                    {
                        mainField: "",
                        foreignField: "prize_id",
                        op: SqlOperation.IN,
                        staticValues: [1, 2, 231]
                    },
                ]
            }
        },
        {
            key: "ref_user",
            title: {ua: "Користувач"},
            detailed: true,
            applyTransform: true,
            type: 'ref',
            ref: {
                entity: "user",
                keys: ['id', 'name', 'email', 'codes', 'free', 'used', 'confirm', 'auth_adjuster_dt'],
                fetchMode: "lazy",
                order: {
                    field: "id",
                    way: "DESC"
                },
                limit: 1,
                single: true,
                layout: "vertical-list",
                condition: [{
                    mainField: "msisdn",
                    op: SqlOperation.EQUAL
                }]
            }
        },

    ]
}
